(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
      .constant(app.modules.common.constants.appsettings,
         {
            gnapi : {
                root : "https://gnapiv2.golfnet.com/"
               , namespace : "GN"
               , login: {
                  token : "Token"
               }
               , scoring: {
                  scores: "scores"
                  , detail: "scores(id)"
                  , post: "scores/postScore" //GN.postScore"
                  , statsummary: "scores/GetStatsSummary(memberId={id},filter='{filter}')"
               }
               , handicap: {
                  handicaps: "handicaps"
                  , detail: "handicaps(id)"
                  , scores: "scores/getHandicapScores" //GN.getHandicapScores"
               }
               , club: {
                  memberships : "memberships"
               }
               , course: {
                  search: "courses"
                  , detail: "courses"
                  , mycourses: "memberCourses"
                  , tee : "tees"
               }
               , member: {
                  search: "members"
                 , detail: "members"
                 , friends: "members(id)?$expand=friends"
                 , passwordreset: "members/resetPassword"
                 , createAuthToken: "members(id)/createAuthToken"
                 , picture : "media(type='Member',id={id})/$value"
               }
            }
            , grpapi: {
                root: "https://grpapiv2.golfnet.com/"
                , namespace: "GRP"
               , group : {
                  search: "groups"
                  , detail: "groups"
                   , membership: "memberships"
                  , handicap: "handicaps"
                  , nearme: "groups/getGroupsNearMe(memberId={id})?$expand=createdBy"
               }
               , location : {
                  postalCode : "getPostalCodeInfo"
               }
               , outing: {
                  search: "outings"
                  , insert: "outings"
                  , detail: "outings(id)"
                  , detailByToken: "getAnonymousOutingInfo(token=(tokenId))"
                  , rounds: "outings(id)/rounds"
                  , courses: "outings(id)/gameCourses"
                  , tees: "outings(id)/gameTees"
                  , holes: "outings(id)/gameHoles"
                  , players: "outings(id)/players"
                  , teetimes: "outings(id)/teeTimes"
                  , games: "outings(id)/games"
                  , teams: "outings(id)/teams"
                  , updatehandicaps: "outings(id)/updateHandicaps"
                  , wagerReport: "outings(id)/rounds(roundId)/getWagerReport" //GRP.getWagerReport"
                  , batchPost: "outings(id)/teeTimes(teeTimeId)/postScores" //GRP.postScores"
                  , getOutingInfo: "outings(id)/getOutingInfo" //GRP.getOutingInfo"
                  , setTeeTimeOrder: "outings(id)/teeTimes(teeTimeId)/setTeeTimeOrder" //GRP.setTeeTimeOrder"
                  , getOutingsByMemberId: "outings/getOutingsByMemberId(memberId=(memberId),includeOrganizing=(includeOrganizing))"
                  , findAGame: "outings/getOutingsNearMe(memberId=(memberId),radius=5000)"
                  , addGameCourse: "outings(id)/addGameCourse"
                  , getOutingToken : "outings(id)/getOutingToken"
               }
               , scoring: {
                  gameScores: "outings(id)/scores"
                  , gameHoleScores: "outings(id)/holeScores"
                   , gameScoreByTeeTime: "/outings({outingId})/scores/getScoreInfoByTeeTime(teeTimeId={teeTimeId})"
                  
               }
               , invitation: {
                  search: "invitations"
                  , detail: "invitations"
               }
               , signalR: 'signalR'
               , networkTime: 'getCurrentUTCTime()'
            }
            , aspapi: {
                root: "https://resources.golfnet.com/_grpapi/"
                //root : "http://localhost:53368/_grpapi/"
               , app: {
                  fetchCompliantClub: "app/fetchCompliantClub.asp"
                  , fetchAppSetup : "app/fetchAppSetup.asp"
               }
               , stripe: {
                   insertStripeBasket: "stripe/insertStripeBasket.asp"
                  , updatePrepaidCode: "stripe/updatePrepaidCode.asp"
                  , fetchStripeCustomerDetail: "stripe/fetchStripeCustomerDetail.asp"
               }
                , ios: {
                    updateIOSPayment: "ios/updateIOSPayment.asp"
                }
            }
            , stripe: {

               products: {
                  clubMembership1Yr: {
                     sourceItemId: null
                     , amount: 2995
                     , productId : "GN1YR"
                  }
                  , clubMembership3Yr: {
                     sourceItemId: null
                     , amount: 6995
                      , productId: "GN3YR"
                  }
                  , clubMembership5Yr: {
                     sourceItemId: null
                     , amount: 8995
                      , productId: "GN5YR"
                  }
                  , prepaidCode : {
                     sourceItemId: 16311
                     , amount: 2995
                      , productId: "GNPPC"
                  }
               }
            }
            , defaultGroupId: 1 // GroupyGolfPublic
            , defaultPassword : "golfisfun123"
            , clubManagementGroupID: 22
            , defaultScrollLimit : 25
            , version : "2.5.1b"
            , authCookieName: "GNAuthToken"
            , forceWWW: false
            , forceSSL : false
            , isHCP: true
            , scoring : {
               allowManualCourse : true
               , allowManualTee : true
            }
            , colors: {
               chartSolids: ["rgba(226,233,234,0.8)", "rgba(138,0,205,0.8)", "rgba(46,209,86,0.8)", "rgba(28,125,213,0.8)", "rgba(233,220,0,0.8)", "rgba(242,154,40,0.8)", "rgba(202,61,58,0.8)", "rgba(33,33,33,0.8)"]
               , chartBorders: ["rgba(226,233,234,1)", "rgba(138,0,205,1)", "rgba(46,209,86,1)", "rgba(28,125,213,1)", "rgba(233,220,0,1)", "rgba(242,154,40,1)", "rgba(202,61,58,1)", "rgba(33,33,33,0.2)"]
            }
         }
      );
}(angular, app));
